
export class Option<T> {
  private constructor(
    public readonly isSome: boolean,
    private readonly _value: T | null = null,
  ) {}

  static some<T>(value: T): Option<T> {
    return new Option(true, value);
  }

  static none<T>(): Option<T> {
    return new Option(false);
  }

  get isNone(): boolean {
    return !this.isSome;
  }

  get value(): T {
    if(this.isNone) {
      throw new Error('value is not accessible on a none instance');
    }

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this._value!;
  }

  getOrElse(defaultValue: T): T {
    return this.isSome ? this.value : defaultValue;
  }

  get valueOrNull(): T | null {
    return this._value;
  }
}
